export function createWorkspaceSlug(
  name: string,
  timestamp: number = Date.now(),
) {
  const base =
    name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "") || "workspace";
  return `${base}-${timestamp.toString(36)}`;
}
